export const updateCurrent = current => ({
  type: 'EDIT_CURRENT_PAGE',
  current
});